<template>
  <div class="school_page">
    <div class="header">
        <i class="icon_fanhui" @click="goBack"></i>
        <p>选择学校</p>
        <span @click="shure" :class="active_school_id?'active':''">确定</span>
    </div>
    <div class="search_area">
        <img src="./img/icon_search.png" class="icon" />
        <input type="text" class="input" v-model.trim="keywords"  placeholder="请输入搜索的关键词">
        <span class="clear" v-if="keywords" @click="clear"><img src="./img/icon_clear.png" class="icon_clear" /></span>
    </div>
    <div class="result">
        <div class="item" v-for="(item,index) in search_result_list" :key="index" @click="handleChoose(item)">
            <p>{{item.school_name}}</p>
            <img src="./img/icon_yes.png" v-if="active_school_id==item.school_id" class="icon" />
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            county_id:this.$route.params.county_id,
            school_list:[],
            active_school_id:null,
            keywords:'',
            timer: null,
        }
    },
    created(){
        this.getSchool()
        localStorage.removeItem('schoolInfo')
    },
    computed: {
        search_result_list () {
            if (this.keywords) {
               let _arr = new Array();
                _arr = this.school_list.filter((item) => {
                    return item.school_name.indexOf(this.keywords) !== -1;
                })
                return _arr;
            } else {
                return this.school_list;
            }

        }
    },
    methods:{
        goBack () {
            this.$router.go(-1);
        },
        shure () {
            if(!this.active_school_id){
                return
            }
            this.$router.replace('/classlist/add')
            this.$router.go(-1);
        },
        getSchool(){
            this.$http.post(API_URL_BASE_API + '/unit/area/school_list/',{
                county_id:this.county_id
            }).then(res => {
                if (res.data.response == 'ok') {
                   this.school_list = res.data.data
                } else {
                    layer.tips(res.data.message)
                }
            })
        },
        handleChoose(item){
            this.active_school_id=item.school_id
            let obj={
                school_name:item.school_name,
                school_id:item.school_id
            }
            localStorage.setItem('schoolInfo',JSON.stringify(obj))
        },
        clear(){
            this.keywords=''
        },  
    }
}
</script>

<style lang="scss" scoped>
.school_page{
    padding-top: $h-header;
    background:#fff;
    min-height: calc(100vh - 2.4rem);
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;

    .icon_fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    span {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        padding: 0 24px/$ppr;
        height: $h-header;
        line-height: $h-header;
        font-size: 28px/$ppr;
        opacity: 0.8;
        &.active{
            opacity: 1;
        }
    }
}
.search_area{
    background:#fff;
    padding:12px/$ppr;
    margin: 24px/$ppr 12px/$ppr;
    background:#F1F1F1;
    border-radius: 10px/$ppr;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .icon{
        width: 36px/$ppr;
        height: 36px/$ppr;
    }
    .input{
        flex: 1;
        font-size: 28px/$ppr;
        line-height: 42px/$ppr;
        margin-left: 10px/$ppr;
        background:transparent;
        border: 0;
    }
    .clear{
        position: absolute;
        top: 18px/$ppr;
        right: 18px/$ppr;
        bottom: 18px/$ppr;
        padding: 8px/$ppr;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px/$ppr;
        height: 30px/$ppr;
        box-sizing: border-box;
        background:#aaa;
        border-radius: 100%;
       
    }
}
.result{
    .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 28px/$ppr;
        padding: 24px/$ppr;
        border-top: 1px/$ppr solid #eaeaea;
        img{
            width: 36px/$ppr;
            height: 36px/$ppr;
        }
    }
}
</style>